import { render, staticRenderFns } from "./BookV2.vue?vue&type=template&id=20261112"
import script from "./BookV2.vue?vue&type=script&lang=js"
export * from "./BookV2.vue?vue&type=script&lang=js"
import style0 from "./BookV2.vue?vue&type=style&index=0&id=20261112&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports